<script>
export default {
  name: "NavigationComponent",
  props: {
    prevStepHandler: {
      type: Function,
      required: true
    },
    validateForm: {
      type: Function,
      required: true
    }
  }
}
</script>

<template>
  <div class="step-nav">
    <div class="row">
      <div class="col-sm-6">
        <a href="#" @click="prevStepHandler">Вернуться назад</a>
      </div>
      <div class="col-sm-6">
        <button v-if="validateForm()" type="submit" class="btn-send-form">Отправить заказ на обработку</button>
        <button v-else type="button" disabled="disabled" class="disabled">Отправить заказ на обработку</button>
      </div>
    </div>
  </div>
</template>

<style scoped>

.step-nav {
  margin-top: 20px;
}

.step-nav .row>.col-sm-6:first-child {
  text-align: left;
}

.step-nav .row>.col-sm-6:last-child {
  text-align: right;
}

.step-nav a,
.step-nav button {
  background-color: #ffffff;
  color: #1b1e21;
  border-radius: 5px;
  padding: 7px;
  border: 1px solid #c7c7c7;
  display: inline-block;
  text-decoration: none;
}

.step-nav .btn-send-form {
  background-color: #3194ca;
  color: #ffffff;
  border: none;
}

.step-nav .disabled {
  background-color: #d3d3d3;
}

@media (max-width: 768px) {
  .step-nav .col-sm-6 {
    width: 50%;
  }
}

</style>
